export default function ie() {
  /**
   * Detect IE and Edge version
   */
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    $('html').addClass(
      'ie ie-' + parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    );
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    $('html').addClass(
      'ie ie-' + parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
    );
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    $('html').addClass(
      'edge edge-' + parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    );
  }
}
